module.exports = __webpack_public_path__ + "img/bad-credit.8924a0ec.svg";